import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { MedidaCautelarService } from 'src/app/dashboard/services/medida-cautelar.service';
import { Cautelar } from 'src/app/dashboard/models/cautelar';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-medida-cautelar',
  templateUrl: './medida-cautelar.component.html',
  styleUrls: ['./medida-cautelar.component.css']
})
export class MedidaCautelarComponent implements OnInit {
  sociedad: string;
  cautelares: Cautelar[];
  IsHiddenForm: boolean = false;
  constructor(private apiService: MedidaCautelarService, private router: Router, private auth: AuthService, private toastr: ToastrService, private translate: TranslateService) { }
  validatingForm: FormGroup;

  idMedida: string;
  nombreCautelar: string;
  comentario: string;

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);
    this.sociedad = this.auth.getNameSociedad();
    this.apiService.searchCautionByUserSociety(this.auth.getSociedad(), language).subscribe({
      next: (cautelar) => {
        this.cautelares = cautelar.data;
      }, error: (err) => {
        this.cautelares = []
      }
    });

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/), // control más estricto y amigable
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
    });
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  deleteCaution(id_mcu: string) {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);
    this.apiService.counMedidaCautelarByIdCompany(this.auth.getSociedad(), id_mcu).subscribe(
      res => {
        if (res == 200) {
          this.apiService.deleteCautionByUser(this.auth.getSociedad(), id_mcu, language).subscribe(
            res => {
              if ((res as any).success === true) {
                this.toastr.success(this.translate.instant('texto_244'), this.translate.instant('texto_247'));
              } else {
                this.toastr.error(this.translate.instant('texto_245'), this.translate.instant('texto_247'));
              }

              this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                this.router.navigate(['/dashboard/layout/medida-cautelar']);
              });
            },
            err => {
              if (err.status === 409) {
                this.toastr.error(this.translate.instant('texto_245'), this.translate.instant('texto_813'));
              } else {
                this.toastr.error(this.translate.instant('texto_245'), this.translate.instant('texto_813'));
              }
            });
        } else {
          this.toastr.error(this.translate.instant('texto_246'), this.translate.instant('texto_247'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/medida-cautelar']);
        });
      });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }

  updateCaution(id_mcu: string) {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }

    let nombreMedidaCautelar = this.signupFormModalName.value;
    if (this.signupFormModalName.value == "") {
      nombreMedidaCautelar = this.nombreCautelar;
    }
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);

    const comentario = this.validatingForm.get('contactFormModalMessage').value;

    this.apiService.updateCautionByUser(this.auth.getSociedad(), id_mcu, nombreMedidaCautelar, comentario, language).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_248'), this.translate.instant('texto_250'));
        } else {
          this.toastr.error(this.translate.instant('texto_249'), this.translate.instant('texto_250'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/medida-cautelar']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_249'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_249'), this.translate.instant('texto_813'));
        }
      });
  }

  showCaution(caution: Cautelar) {
    this.IsHiddenForm = true;

    this.validatingForm.patchValue({
      signupFormModalId: caution.id_mcu,
      signupFormModalName: caution.nombre,
      contactFormModalMessage: caution.comentario
    });


    // Activar labels flotantes si es necesario
    setTimeout(() => {
      document.querySelectorAll('label').forEach(label => label.classList.add('active'));
    }, 100);
  }



}
